import { BehaviorSubject, debounceTime } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    private loadingSubject = new BehaviorSubject(false);
    private activeRequests = new Map<string, boolean>();
    loading$ = this.loadingSubject.asObservable().pipe(debounceTime(100));

    constructor() {}

    showLoading(requestId: string) {
        this.activeRequests.set(requestId, true);
        this.updateLoadingState();
    }

    hideLoading(requestId: string) {
        this.activeRequests.delete(requestId);
        this.updateLoadingState();
    }

    private updateLoadingState() {
        const hasActiveRequests = this.activeRequests.size > 0;
        this.loadingSubject.next(hasActiveRequests);
    }

    resetLoading() {
        this.activeRequests.clear();
        this.loadingSubject.next(false);
    }

    getActiveRequests(): string[] {
        return Array.from(this.activeRequests.keys());
    }
}
